import styled from 'styled-components';
import MuiAppBar from '@mui/material/AppBar';
import { Box } from '@mui/material';
/* export const AppBar = styled.div<AppBarProps>` */
export const AppBar = styled(MuiAppBar) `
  transition: none !important;
  transition-property: margin, width !important;
  transition-duration: ${(props) => props.theme.transitions.duration.leavingScreen} !important;
  transition-timing-function: ${(props) => props.theme.transitions.easing.sharp} !important;
  ${(props) => props.open &&
    `
      transition-duration: ${props.theme.transitions.duration.enteringScreen} !important;
      transition-timing-function:${props.theme.transitions.easing.easeOut} !important;
      `}
  margin-left: ${(props) => (props.open ? `${props.drawerwidth}px` : '0px')};
`;
export const ButtonsWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;
export const LogoContainer = styled(Box) `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
